import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icon_15.png'


const _withScopeId = n => (_pushScopeId("data-v-7f045d49"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fz-18 co-1F2D48 font-blod" }, "拒绝原因", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "wh-12",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "fz-15 co-1F2D48 plr-18" }
const _hoisted_5 = { class: "flex-row-center-end pr-20 pb-20 pt-20" }

import { ref, withDefaults, getCurrentInstance } from 'vue';
import translate from '@/api/translate';

interface main {
	sureText?: string,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'RejectReson',
  props: {
    sureText: { default: "确认拒绝" }
  },
  emits: ["change"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const { proxy } = getCurrentInstance() as any;
const props = __props;
const emits = __emit;
const pop = ref(false);
const remark = ref("");

const submit = () => {
	if (!remark.value) {
		proxy.$message.error("请输入拒绝原因");
		return false;
	}
	close();
	emits("change", remark.value);
};
const open = () => {
	pop.value = true;
};
const close = () => {
	pop.value = false;
};

__expose({
	open,
	close,
});

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_dialog, {
      modelValue: pop.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((pop).value = $event)),
      title: "",
      width: "504px",
      "show-close": false,
      "destroy-on-close": "",
      "align-center": true
    }, {
      header: _withCtx(() => [
        _createElementVNode("div", { class: "flex-row-center-sb pl-20 ptb-20" }, [
          _hoisted_1,
          _createElementVNode("div", {
            class: "pr-20 pointer",
            onClick: close
          }, _hoisted_3)
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_el_input, {
            class: "fz-15",
            autosize: { minRows: 6 },
            type: "textarea",
            resize: "none",
            modelValue: remark.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((remark).value = $event)),
            placeholder: _unref(translate).ShowText('请输入')
          }, null, 8, ["modelValue", "placeholder"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_el_button, {
            class: "cancel-btn",
            onClick: close
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(translate).ShowText('取消')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            class: "sure-btn",
            type: "primary",
            onClick: submit
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(props.sureText), 1)
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})